import { ref } from 'vue'
import { defineStore } from 'pinia'
import apiClient from '@/utils/apiClient'

export const useManufacturersStore = defineStore('manufacturers', () => {
  const manufacturers = ref([])
  const loading = ref(true)
  const error = ref(null)
  let fetchPromise = null

  async function fetchManufacturers(params = {}) {
    if (fetchPromise) return fetchPromise

    loading.value = true
    error.value = null

    fetchPromise = apiClient
      .get('/manufacturers', { params })
      .then(({ data }) => {
        manufacturers.value = data.data
      })
      .catch((e) => {
        error.value = e
      })
      .finally(() => {
        loading.value = false
        fetchPromise = null
      })

    return fetchPromise
  }

  return { manufacturers, loading, error, fetchManufacturers }
})
